<template>
    <div :class="{'alert alert-light' : !inRenderMode}">
        <div v-if="!inRenderMode">
            <div style="color: black" v-html="currentField.htmlContent"></div>
            <br>
            <b-button @click="showModal">Preview Modal</b-button>
        </div>
        <b-modal scrollable centered  hide-footer :ref="`my-modal-${currentField.id}`" v-model="localVisible" :title="currentField.label">
          <div class="d-block text-center" v-html="currentField.htmlContent"></div>
          <b-button class="mt-3" variant="outline-primary" @click="hideModal">Ok</b-button>
        </b-modal>
  </div>
</div>
</template>

<script>
export default {
  name: 'ModalComponent',
  props: ['currentField', 'visible', 'inRenderMode'],
  data() {
    return {
        localVisible: false,
    }
  },

  watch: {
    visible(value) {
        console.log(value)
        this.localVisible = value
    }
  },

  methods: {
      showModal() {
        this.$refs['my-modal-' + this.currentField.id].show()
      },
      hideModal() {
        this.$refs['my-modal-' + this.currentField.id].hide()
      },
      toggleModal() {
        this.$refs['my-modal-' + this.currentField.id].toggle('#toggle-btn')
      }
    }
}
</script>
<style type="text/css">
    .modal-header {
        height: 50px!important;
    }
</style>
